import React from 'react';

import {
  AutocompleteArrayInput,
  BooleanInput,
  ReferenceArrayInput,
  SelectInput,
  SelectArrayInput,
} from 'react-admin';

import { Box } from '@mui/material';

import { pingStatusChoices } from '../../../../constants/pingStatuses';
import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import RuleSelector from '../../../utils/RuleSelector';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const errorPingsChoices = [
  { id: 'include', name: 'include' },
  { id: 'without', name: 'without' },
  { id: 'only', name: 'only' },
];

const PingOverview = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Rules" description="Filter to only include pings generated by specific rules. Leave empty to include all rules.">
      <RuleSelector source="report.originationChainIds" label="" field="originationChainId" helperText={false} />
    </FieldBox>
    <FieldBox title="Ping statuses" description="Filter to only include pings with these statuses. Leave empty to include all statuses (confirmed, pending, ignored, resolved).">
      <SelectArrayInput
        choices={pingStatusChoices}
        fullWidth
        label=""
        source="report.pingStatuses"
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Error pings" description="Choose whether to include all pings, exclude error pings, or only include error pings.">
      <SelectInput
        choices={errorPingsChoices}
        fullWidth
        label=""
        source="report.errorPings"
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Tag" description="Filter to only include pings that have these tags assigned. Leave empty to include pings with any tag.">
      <ReferenceArrayInput perPage={100} source="report.tagIds" reference="tags" filter={{ active: true }}>
        <AutocompleteArrayInput
          fullWidth
          label=""
          filterToQuery={(searchText: string) => ({ name: searchText })}
          optionText="name"
          helperText={false}
        />
      </ReferenceArrayInput>
    </FieldBox>
    <FieldBox title="Date range" description="Only pings created within this date range are included. 'Date from' defaults to 1970-01-01; 'date to' defaults to the generation date.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[isPastDate, dateRangeValidation]} source="report.from" helperText={false} label="From" />
        )}
        to={(
          <SmartDateInput fullWidth validate={[dateRangeValidation]} source="report.to" helperText={false} label="To" />
        )}
      />
    </FieldBox>
    <FieldBox title="Only include test pings" description="If enabled, only test pings are included in the report. If disabled, only non-test pings are included." inline>
      <BooleanInput source="report.onTestPings" label="" helperText={false} defaultValue={false} />
    </FieldBox>
  </Box>
);

export default PingOverview;
